var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuzzleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.99712V12.4932C1 14.1501 2.34315 15.4932 4 15.4932H16.4922C18.149 15.4932 19.4922 14.1501 19.4922 12.4932L19.4961 5.99712M1 5.99712V4C1 2.34315 2.34315 1 4 1H16.4961C18.1529 1 19.4961 2.34315 19.4961 4V5.99712M1 5.99712H19.4961",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzleIcon);
export default __webpack_public_path__ + "static/media/puzzle-icon.2577535c7efd8b999fd200dd55f459b4.svg";
export { ForwardRef as ReactComponent };